var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckmarkIcon = function SvgCheckmarkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "A4374680-6505-4BCD-9689-FCCD4E1F33EC@1.50x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dialogues",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Logged-in-BTW-Dialog",
    transform: "translate(-395.000000, -383.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(341.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification-Modal",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(54.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1283901,7.67854535 L8.89254318,20.0943312 C8.40408725,20.5899703 7.6063206,20.5957934 7.11068149,20.1073375 C7.1079491,20.1046447 7.10522902,20.1019394 7.10252134,20.0992218 L0.871163051,13.8449541 C0.387153843,13.3591654 0.380510235,12.5755031 0.856213785,12.0815783 L2.84196705,10.0197633 C3.32469568,9.51854443 4.12234275,9.50355509 4.62356166,9.98628372 C4.63145398,9.99388488 4.63924681,10.0015887 4.64693816,10.0093931 L8,13.4117647 L8,13.4117647 L17.3634356,3.91063155 C17.8518915,3.41499244 18.6496582,3.40916933 19.1452973,3.89762526 C19.1496643,3.90192898 19.1539998,3.90626453 19.1583036,3.91063155 L21.1283901,5.90968995 C21.6118115,6.4002205 21.6118115,7.1880148 21.1283901,7.67854535 Z",
    id: "Path"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark_icon.cd223480.svg";
export { ForwardRef as ReactComponent };